import React from "react";
import { motion } from "framer-motion";
import exeLogoSVG from "../../assets/images/exelogo.svg";

const EXEHero = () => {
  return (
    <section className="exe-section py-24 relative overflow-hidden">
      <div className="exe-container">
        <div className="text-center relative z-10">
          {/* Main Logo/Title */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.12 }}
            className="mb-8"
          >
            <div className="flex justify-center items-center mb-4">
              <img
                src={exeLogoSVG}
                alt="EXE Logo"
                className="h-32 md:h-40 lg:h-48 w-auto filter brightness-110"
              />
            </div>
            <div className="h-1 w-32 bg-exe-gradient-primary mx-auto mb-6"></div>
          </motion.div>

          {/* Subtitle */}
          <motion.h2
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.36 }}
            className="exe-subtitle text-exe-text-secondary mb-8"
          >
            Sri Lanka's Flagship Game Development Competition
          </motion.h2>

          {/* Description */}
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.48 }}
            className="exe-text text-xl max-w-3xl mx-auto mb-12"
          >
            Organized by{" "}
            <a 
              href="https://www.levelstair.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-exe-primary hover:text-exe-accent transition-colors underline"
            >
              LEVELSTAIR
            </a>
            , where innovation meets opportunity. Join developers from across the
            nation to create groundbreaking games, connect with industry
            leaders, and compete for life-changing prizes.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-6 justify-center"
          >
            {/* <motion.a
              href="/register"
              className="exe-btn exe-btn-primary text-lg px-8 py-4"
              whileHover={{ scale: 1.05, boxShadow: "0 0 30px rgba(0, 255, 65, 0.6)" }}
              whileTap={{ scale: 0.95 }}
            >
              Register Now
            </motion.a> */}

            <motion.a
              href="/rules"
              className="exe-btn exe-btn-outline text-lg px-8 py-4"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              View Competition Details
            </motion.a>

            <motion.a
              href="/stats"
              className="exe-btn exe-btn-primary text-lg px-8 py-4"
              whileHover={{ scale: 1.05, boxShadow: "0 0 30px rgba(0, 255, 65, 0.6)" }}
              whileTap={{ scale: 0.95 }}
            >
              View EXE2025 Stats
            </motion.a>
          </motion.div>

          {/* Key Stats */}
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.72 }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 max-w-4xl mx-auto"
          >
            <div className="text-center">
              <div className="text-3xl font-bold text-exe-text-accent mb-2">
                LKR 200K
              </div>
              <div className="exe-text">Total Prize Pool</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-exe-text-accent mb-2">
                2
              </div>
              <div className="exe-text">Competition Categories</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-exe-text-accent mb-2">
                15+
              </div>
              <div className="exe-text">Industry Partners</div>
            </div>
          </motion.div>
        </div>

        {/* Background Effects */}
        <div className="absolute inset-0 pointer-events-none">
          {/* Glowing orbs */}
          <motion.div
            className="absolute top-1/4 left-1/4 w-64 h-64 bg-exe-primary opacity-5 rounded-full blur-3xl"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.05, 0.1, 0.05],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
          <motion.div
            className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-exe-accent opacity-3 rounded-full blur-3xl"
            animate={{
              scale: [1.2, 1, 1.2],
              opacity: [0.03, 0.08, 0.03],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 1.2,
            }}
          />

          {/* Grid pattern */}
          <div className="absolute inset-0 bg-exe-matrix-pattern opacity-10" />
        </div>
      </div>
    </section>
  );
};

export default EXEHero;
